import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/$tenantSlug/_layout/affiliate/_layout/commission/_layout")({
    component: () => <Outlet />,
    loader: ({ context: { t } }) => {
        return {
            breadcrumb: t("pages.affiliate.commission.title"),
        };
    },
});
